import {useState} from 'react';

import {liveAccessService} from '@/services/liveAccessService';
import {BusinessLiveAccessStatus} from '@/types';
import {getErrorMessage} from '@/utils/errorMessage';
import {showErrorMessage} from '@/utils/showErrorMessage';
import {showSuccessMessage} from '@/utils/showSuccessMessage';

export const useLiveAccessActions = (
  request: {id: string; businessId: string},
  onDone: () => void,
) => {
  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);

  const approve = async () => {
    setIsApproving(true);
    try {
      await liveAccessService.update(request.id, {
        status: BusinessLiveAccessStatus.Approved,
      });
      showSuccessMessage('Live access approved');
      onDone();
    } catch (e) {
      showErrorMessage(getErrorMessage(e, 'Error approving live access'));
    } finally {
      setIsApproving(false);
    }
  };

  const reject = async (note: string) => {
    setIsRejecting(true);
    try {
      await liveAccessService.update(request.id, {
        status: BusinessLiveAccessStatus.Rejected,
        note: note?.trim() || undefined,
      });
      showSuccessMessage('Live access rejected');
      onDone();
    } catch (e) {
      showErrorMessage(getErrorMessage(e, 'Error rejecting live access'));
    } finally {
      setIsRejecting(false);
    }
  };

  return {
    isApproving,
    isRejecting,
    approve,
    reject,
  };
};

export default useLiveAccessActions;
